import { combineReducers } from "redux";
import { authenticationReducer } from "./authentication-store";
export const reducer = combineReducers({
    authentication: authenticationReducer
});
